import { render } from "./LivePage.vue?vue&type=template&id=52c9dd1c&scoped=true"
import script from "./LivePage.vue?vue&type=script&lang=js"
export * from "./LivePage.vue?vue&type=script&lang=js"

import "./LivePage.vue?vue&type=style&index=0&id=52c9dd1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c9dd1c"]])

export default __exports__